<template>
  <div class="card">
    <div class="card-body">
      <a-table :columns="cols" :data-source="tabledata">
      </a-table>
    </div>
  </div>
</template>

<script>
const cols = [
  {
    title: 'Product Code',
    dataIndex: 'product_code',
    scopedSlots: { customRender: 'product_code' },
  },
  {
    title: 'Product Name',
    dataIndex: 'product_name',
    scopedSlots: { customRender: 'product_name' },
  },
  {
    title: 'Current Quantity',
    dataIndex: 'current_quantity',
    scopedSlots: { customRender: 'quantity' },
  },
  {
    title: 'Minimum Quantity',
    dataIndex: 'minimum_quantity',
    scopedSlots: { customRender: 'minimum_quantity' },
  },
  {
    title: 'Maximum Quantity',
    dataIndex: 'maximum_quantity',
    scopedSlots: { customRender: 'maximum_quantity' },
  },
  {
    title: 'Status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'maximum_quantity' },
  },
]

export default {
  name: 'StockLevelTable',
  props: ['loading', 'data'],
  data: function () {
    return {
      cols,
      tabledata: [],
    }
  },
  watch: {
    data(newVal) {
      console.log(newVal)
      this.tabledata = newVal.map(td => ({
        product_code: td.code,
        product_name: td.name,
        current_quantity: td.product_stock.quantity,
        minimum_quantity: td.product_stock.min_quantity,
        maximum_quantity: td.product_stock.max_quantity,
        status: td.product_stock.status,
      }))
    },
  },
}
</script>
